import type { IModalLogoutTranslations } from '@/Contexts/GLModalLogout/types/translations';

const esES: IModalLogoutTranslations = {
  title: 'Sesión expirada',
  description:
    'Su sesión ha expirado por razones de seguridad. Haga clic en OK para iniciar sesión nuevamente.',
  buttonText: 'Ok',
};

export { esES };
